const config = {
  port: parseInt(process.env.PORT, 10),
  proxyTarget: process.env.PROXY_TARGET,
  appSecret: process.env.APP_SECRET,
  db: {
    username: process.env.DB_USERNAME,
    password: process.env.DB_PASSWORD,
    database: process.env.DB_DATABASE,
    host: process.env.DB_HOST,
    logging: process.env.DB_LOGGING === 'true',
  },
  gocardless: {
    host: process.env.GOCARDLESS_HOST,
    apiToken: process.env.GOCARDLESS_API_TOKEN,
    webhookSecret: process.env.GOCARDLESS_WEBHOOK_SECRET,
  },
  mail: {
    fromEmail: process.env.FROM_EMAIL,
    provider: process.env.MAIL_PROVIDER,
  },
  smpt: {
    host: process.env.SMTP_HOST,
    service: process.env.SMTP_SERVICE,
    auth: {
      user: process.env.SMTP_AUTH_USER,
      pass: process.env.SMTP_AUTH_PASS,
    },
  },
  sendgrid: {
    apiKey: process.env.SENDGRID_API_KEY,
    path: process.env.SENDGRID_PATH,
  },
  sagepay: {
    url: process.env.SAGEPAY_URL,
    account: process.env.SAGEPAY_ACCOUNT,
  },
  apiUrl: process.env.API_URL,
  siteUrl: process.env.SITE_URL,
  dbSalt: process.env.DB_SALT,
  customerHelpline: process.env.CUSTOMER_HELPLINE,
  SPProviderName: process.env.SP_PROVIDER_NAME,
  SPName: process.env.SP_NAME,
  vatNumber: process.env.VAT_NUMBER,
  companyDirectorName: process.env.COMPANY_DIRECTOR_NAME,
  carVrnReferer: process.env.CAR_VRN_REFERER,
  WCFMCBankDetails: {
    sortCode: process.env.WCFMC_BANK_SORT_CODE,
    accountNumber: process.env.WCFMC_BANK_ACCOUNT_NUMBER,
  },
};

module.exports = config;
